import { CheckCircle2 } from 'lucide-react';
import {
  Dialog,
  DialogShell,
  DialogShellBody,
  DialogShellFooter,
  DialogShellHeader
} from '@bliks-io/ui';

interface ReviewSuccessScreenProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  finishLabel: string;
  onFinish: () => void;
}

/**
 * Shared success screen for review modals.
 */
export function ReviewSuccessScreen({
  open,
  onOpenChange,
  title,
  description,
  finishLabel,
  onFinish
}: ReviewSuccessScreenProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogShell size="lg">
        <DialogShellHeader
          icon={<CheckCircle2 className="h-5 w-5" />}
          iconTone="green"
          title={title}
          subtitle={description}
          onClose={() => onOpenChange(false)}
        />
        <DialogShellBody>
          <div className="flex justify-center py-6">
            <img src="/assets/images/create-process-success.png" alt="" className="w-[200px]" />
          </div>
        </DialogShellBody>
        <DialogShellFooter
          primary={{
            label: finishLabel,
            onClick: onFinish
          }}
        />
      </DialogShell>
    </Dialog>
  );
}
